import { X } from "lucide-react";
import { Button } from "react-aria-components/Button";
import type { ApiBlockGridItemModel } from "#/_generated/umbraco/delivery-api/models";
import { Sheet } from "#/_packages/umbrella/features/sheet/components/sheet.tsx";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import {
	BlockGridItemRenderer,
	BuildHeaderModel,
} from "#/_packages/umbrella/integrations/umbraco/utils/blockgrid-item-renderer.tsx";
import { m } from "#/paraglide/messages";

export default function HeaderDrawer() {
	const siteSettings = useGetSiteSettings();
	const headerModel = BuildHeaderModel(siteSettings?.headerContentArea?.items);

	return (
		<Sheet
			className="header-drawer-wrapper"
			isDismissable
			dialogProps={{ "aria-label": m.main_navigation() }}
		>
			{({ state }) => (
				<>
					<div
						className="grid grid-cols-1 gap-4"
						// React Aria links consume bubbling clicks. Observe activation
						// in capture, then let the link finish before unmounting it.
						onClickCapture={(event) => {
							if (
								event.target instanceof Element &&
								event.target.closest("a[href]")
							) {
								setTimeout(() => state.close(), 0);
							}
						}}
					>
						{headerModel.drawerSections.map((section) => (
							<HeaderDrawerItem
								item={section.block}
								key={`${section.id}-${section.block.content.id}`}
							/>
						))}
					</div>
					<Button
						slot="close"
						className="btn-header-drawer-close"
						aria-label={m.common_close()}
					>
						<X aria-hidden="true" />
					</Button>
				</>
			)}
		</Sheet>
	);
}

function HeaderDrawerItem({ item }: { item: ApiBlockGridItemModel }) {
	return (
		<BlockGridItemRenderer model={item} options={{ isHeaderDrawer: true }} />
	);
}
